function useConvertToCamelCase(str) {
  if (typeof str !== 'string') {
    return '';
  }

  return str
    .replace(/[-\s]+(.)?/g, (match, chr) => (chr ? chr.toUpperCase() : ''))
    .replace(/(?:^\w|[A-Z])/g, (word, index) => (index === 0 ? word.toLowerCase() : word));
}
export { useConvertToCamelCase };
